export type DisplayFormat = 'map' | 'calendar';

export const getEffectiveDisplayFormat = (
  displayFormat: DisplayFormat,
  isPremium: boolean
): DisplayFormat => {
  if (!isPremium && displayFormat === 'map') {
    return 'calendar';
  }
  return displayFormat;
};
